__webpack_require__.p = "/Programowanie_w_jezykach_skryptowych/KajaThiel21310/Lab_10prod/";